import React from 'react';
import "./Rule.scss";

const Rule = ({rule}) => {
	const {
		zasada_tytul,
		zasada_opis,
		zasada_obraz,
	} = rule;
	return (
		<div className="philosophy__rule row">
			<div className="col col-xs-12">
				<img src={zasada_obraz} width={1320} height={600} alt="" />
				<h3>{zasada_tytul}</h3>
				<p dangerouslySetInnerHTML={{__html:zasada_opis}}/>
			</div>
		</div>
	);
};

export default Rule;